"use strict";

const CompositeAssetId = function () {
  var build = function (assetType, rawId) {
    return `${assetType}-${rawId}`;
  };

  var parse = function (compositeId) {
    const separatorIndex = compositeId.lastIndexOf("-");

    return {
      assetType: compositeId.slice(0, separatorIndex),
      id: Number(compositeId.slice(separatorIndex + 1)),
    };
  };

  return {
    build,
    parse,
  };
};

module.exports = CompositeAssetId();
